import 'flag-icons/css/flag-icons.min.css';
export default defineNuxtPlugin(() => { });